import React from 'react';
import styles from './ReviewsModal.module.css';

interface Review {
  rating: number;
  text: string;
  name: string;
}

interface ReviewsModalProps {
  isOpen: boolean;
  onClose: () => void;
  reviews: Review[];
}

const ReviewsModal: React.FC<ReviewsModalProps> = ({ isOpen, onClose, reviews }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalBackdrop} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e: React.MouseEvent) => e.stopPropagation()}>
        <h2 className={styles.title}>All Reviews</h2>
        <button className={styles.closeButton} onClick={onClose}>✕</button>
        <div className={styles.reviewList}>
          {reviews.map((review, index) => (
            <div key={index} className={styles.reviewCard}>
              <div className={styles.stars}>
                {'★'.repeat(review.rating)}
                {'☆'.repeat(5 - review.rating)}
              </div>
              <p className={styles.reviewText}>"{review.text}"</p>
              <p className={styles.reviewerName}>— {review.name}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewsModal;